/******************************************************************************
 *** MbrasWthdHistory ** 원천징수 변경 이력 조회
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import Util from "@/js/common/Util";
import React from "react";

interface Props {
    mbrasId      : string;
    setModalOpen : Function;
}

interface WthdHistoryRow {
    mbrasAtrzDocId: string; // 결재문서 ID
    mbrasId       : string; // 조합원 ID
    mbrasAtrzSeCd : string; // 조합원 결재구분코드
    applyDt       : string; // 신청일자
    atrzReqDt     : string; // 상신일자
    atrzDt        : string; // 승인일자
    regMm         : string; // 등록월
    wthdStatusCd  : string; // 원천징수 상태코드
}

const MbrasWthdHistory = ({ mbrasId, setModalOpen }: Props) => {
    const [mbrasNm          , setMbrasNm          ] = React.useState("");  // 성명
    const [telno            , setTelno            ] = React.useState("");  // 휴대전화번호
    const [brdtDate         , setBrdtDate         ] = React.useState("");  // 생년월일
    const [gndrCd           , setGndrCd           ] = React.useState("");  // 성별
    const [upOgnzNm         , setUpOgnzNm         ] = React.useState("");  // 본부명
    const [ognzNm           , setOgnzNm           ] = React.useState("");  // 지부명
    const [wtjrNm           , setWtjrNm           ] = React.useState("");  // 관내
    const [mbrasJoinSttsCd  , setMbrasJoinSttsCd  ] = React.useState("");  // 조합가입상태
    const [years            , setYears            ] = React.useState("");  // 가입기간 연수
    const [months           , setMonths           ] = React.useState("");  // 가입기간 개월수
    const [historyData      , setHistoryData      ] = React.useState<WthdHistoryRow[]>([]); // 원천징수 변경 이력

    React.useEffect(() => {
        setMbrasNm("");
        setTelno("");
        setBrdtDate("");
        setGndrCd("");
        setUpOgnzNm("");
        setOgnzNm("");
        setWtjrNm("");
        setMbrasJoinSttsCd("");
        setYears("");
        setMonths("");
        setHistoryData([]);

        if (Util.isEmpty(mbrasId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasId: mbrasId,
            },
            onSuccessFn: (res: any) => {
                const item = res.result.item;

                setMbrasNm(item.mbrasNm);
                setTelno(item.telno);
                setBrdtDate(item.brdtDate);
                setGndrCd(item.gndrCd);
                setUpOgnzNm(item.upOgnzNm);
                setOgnzNm(item.ognzNm);
                setWtjrNm(item.wtjrNm);
                setMbrasJoinSttsCd(item.mbrasJoinSttsCd);

                Axios.dataAccess({
                    url       : "system/mbras/mng/select-mbras-atrz-wthd-history.do",
                    methodType: "post",
                    paramType : "json",
                    paramData : {
                        mbrasId: mbrasId,
                    },
                    onSuccessFn: (historyRes: any) => {
                        const list       = Array.isArray(historyRes.result.list) ? historyRes.result.list : [];
                        const periodItem = historyRes.result.item;

                        setHistoryData(list);

                        if (Util.isNotEmpty(periodItem)) {
                            setYears(periodItem.years);
                            setMonths(periodItem.months);
                        }

                        AppContext.hideSpinner();
                    },
                });
            },
        });
    }, [mbrasId]);

    const isWithdraw = mbrasJoinSttsCd === "03" || mbrasJoinSttsCd === "06" || mbrasJoinSttsCd === "07";

    const renderValue = (value: string) => {
        return Util.isEmpty(value) ? "-" : value;
    };

    const totalYears   = Number(years);
    const remainMonths = Number(months);

    const totalJoinPeriod = totalYears === 0 ? `${remainMonths}개월` : `${totalYears}년 ${remainMonths}개월`;

    const closeModal = () => setModalOpen(false);

    return (
        <div
            className="w100p bsBdb p10"
            style={{
                minHeight    : "100%",
                boxSizing    : "border-box",
                display      : "flex",
                flexDirection: "column",
            }}
        >
            <div style={{ flex: 1 }}>
            {/* 조합원 정보 */}
            <div className="mt5">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111111 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    조합원 정보
                </div>

                <div
                    className="bd1 bdcDDDDDD bdrd10 bgcWhite"
                    style={{ boxShadow: "0 5px 16px rgba(31, 41, 55, 0.04)", overflow: "hidden" }}
                >
                    {isWithdraw ? (
                        <React.Fragment>
                            {/* 1행 */}
                            <div className="dpFlx bdb1 bdcDDDDDD">
                                <div className="dpFlx flx1">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        성명
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(mbrasNm)}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        본부
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(upOgnzNm)}
                                    </div>
                                </div>
                            </div>

                            {/* 2행 */}
                            <div className="dpFlx">
                                <div className="dpFlx flx1">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        지부
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(ognzNm)}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        관내
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(wtjrNm)}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            {/* 1행 */}
                            <div className="dpFlx bdb1 bdcDDDDDD">
                                <div className="dpFlx flx1">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        성명
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(mbrasNm)}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        휴대전화번호
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.setPhoneNum(telno))}
                                    </div>
                                </div>
                            </div>

                            {/* 2행 */}
                            <div className="dpFlx">
                                <div className="dpFlx flx1">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        생년월일
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.cvtDateStrForm(brdtDate, "-", "YYYYMMDD"))}
                                    </div>
                                </div>

                                <div className="dpFlx flx1 bdl1 bdcDDDDDD">
                                    <div className="w120 h46 dpFlx aiC jcC bsBdb pl12 pr12 bgcFAFAFA fm-b fs13 fc4B5563 ls06 bdr1 bdcDDDDDD">
                                        성별
                                    </div>
                                    <div className="flx1 h46 dpFlx aiC bsBdb pl18 pr18 bgcWhite fm-c fs14 fc222222 ls06">
                                        {renderValue(Util.getValToCode("GNDR_CD", gndrCd))}
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            </div>

            {/* 원천징수 변경 이력 */}
            <div className="mt18">
                <div className="dpFlx aiC gap8 mb10 fm-b fs15 fc111111 ls06">
                    <span className="w4 h16 bdrd2 bgc007bff" />
                    원천징수 변경 이력
                </div>

                <div
                    className="bd1 bdcDDDDDD bdrd10 bgcWhite"
                    style={{ boxShadow: "0 5px 16px rgba(31, 41, 55, 0.04)", overflow: "hidden" }}
                >
                    <table
                        className="w100p"
                        style={{ borderCollapse: "collapse", tableLayout: "fixed" }}
                    >
                        <colgroup>
                            <col style={{ width: "7%" }} />
                            <col style={{ width: "11%" }} />
                            <col style={{ width: "17%" }} />
                            <col style={{ width: "17%" }} />
                            <col style={{ width: "17%" }} />
                            <col style={{ width: "15%" }} />
                            <col style={{ width: "16%" }} />
                        </colgroup>

                        <thead>
                            <tr className="h42 bgcFAFAFA bdb1 bdcDDDDDD">
                                <th className="fm-b fs13 fc4B5563 bdr1 bdcDDDDDD">
                                    번호
                                </th>
                                <th className="fm-b fs13 fc4B5563 bdr1 bdcDDDDDD">
                                    구분
                                </th>
                                <th className="fm-b fs13 fc4B5563 bdr1 bdcDDDDDD">
                                    신청일자
                                </th>
                                <th className="fm-b fs13 fc4B5563 bdr1 bdcDDDDDD">
                                    상신일자
                                </th>
                                <th className="fm-b fs13 fc4B5563 bdr1 bdcDDDDDD">
                                    승인일자
                                </th>
                                <th className="fm-b fs13 fc4B5563 bdr1 bdcDDDDDD">
                                    등록월
                                </th>
                                <th className="fm-b fs13 fc4B5563">
                                    원천징수
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {historyData.map((item: WthdHistoryRow, index: number) => (
                                <tr
                                    key={item.mbrasAtrzDocId}
                                    className={`h42${index < historyData.length - 1 ? " bdb1 bdcDDDDDD" : ""}`}
                                >
                                    <td className="fm-c fs14 fc222222 taC bdr1 bdcDDDDDD">
                                        {index + 1}
                                    </td>
                                    <td className="fm-c fs14 fc222222 taC bdr1 bdcDDDDDD">
                                        {renderValue(Util.getValToCode("MBRAS_ATRZ_SE_CD", item.mbrasAtrzSeCd))}
                                    </td>
                                    <td className="fm-c fs14 fc222222 taC bdr1 bdcDDDDDD">
                                        {renderValue(Util.cvtDateStrForm(item.applyDt, "-", "YYYYMMDD"))}
                                    </td>
                                    <td className="fm-c fs14 fc222222 taC bdr1 bdcDDDDDD">
                                        {renderValue(Util.cvtDateStrForm(item.atrzReqDt, "-", "YYYYMMDD"))}
                                    </td>
                                    <td className="fm-c fs14 fc222222 taC bdr1 bdcDDDDDD">
                                        {renderValue(Util.cvtDateStrForm(item.atrzDt, "-", "YYYYMMDD"))}
                                    </td>
                                    <td className="fm-c fs14 fc222222 taC bdr1 bdcDDDDDD">
                                        {renderValue(Util.cvtMonthStrForm(item.regMm))}
                                    </td>
                                    <td className="fm-c fs14 fc222222 taC">
                                        {renderValue(Util.getValToCode("WTHD_STATUS_CD", item.wthdStatusCd))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                        <tfoot>
                            <tr className="h46 bgcFAFAFA bdt1 bdcDDDDDD">
                                <td colSpan={7}>
                                    <div className="dpFlx aiC jcC gap8">
                                        <span className="fm-c fs13 fc4B5563">
                                            가입기간
                                        </span>
                                        <span className="fm-c fs15 fc111111">
                                            {totalJoinPeriod}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            </div>

            {/* 버튼 */}
            <div className="dpFlx jcC mt25 mb20">
                <Button
                    width={100}
                    height={40}
                    fontFamily="fm-b"
                    fontSize={16}
                    letterSpacing={-1}
                    variant="styCloseBtn"
                    borderRadius={6}
                    buttonClass="dpFlx aiC jcC"
                    buttonName="닫기"
                    onClickFunc={closeModal}
                />
            </div>
        </div>
    );
};

export default MbrasWthdHistory;
